
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_toolpad/[[...index]]",
      function () {
        return require("private-next-pages/_toolpad/[[...index]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_toolpad/[[...index]]"])
      });
    }
  